import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import type { ApiResponse } from '@/types/api-response';
import { PP_BASE_URL } from '@/lib/env';

export interface ApplicationStudent {
  source_ID: string;
  studentNumber?: string;
  emiratesId?: string;
  firstNameArabic?: string;
  middleNameArabic?: string;
  lastNameArabic?: string;
  firstNameEnglish?: string;
  middleNameEnglish?: string;
  thirdNameEnglish?: string;
  fourthNameEnglish?: string;
  familyNameEnglish?: string;
}

export interface ApplicationData {
  id: number;
  applicationType: string;
  status_ID: number;
  returnComment?: string | null;
  createdAt: string;
  student: ApplicationStudent;
}

export function useGetApplications() {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key = baseUrl ? `${baseUrl}/applications` : null;

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useSWR<ApiResponse<ApplicationData[]> | ApplicationData[]>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  const applications: ApplicationData[] = Array.isArray((response as ApiResponse<ApplicationData[]>)?.data)
    ? (response as ApiResponse<ApplicationData[]>).data!
    : Array.isArray(response)
      ? response
      : [];

  return {
    swrKey: key,
    applications,
    isLoading,
    error,
    mutate,
  };
}
